import React, { useState } from "react";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function FAQ() {
  const [isMobile] = useState(window.innerWidth <= 768);

  const faqs = [
    {
      q: "Is OGESTYLE free to join?",
      a: "Customers can sign up for free. Business and freelancer account pricing depends on the selected plan and features.",
    },
    {
      q: "Can professionals work without owning a business?",
      a: "Yes. If you are independent, the freelancer path is designed for you. If you want to join a business team, job posting support is coming soon.",
    },
    {
      q: "How do businesses start?",
      a: "Go to For Businesses, review requirements, and register your business account to begin onboarding.",
    },
    {
      q: "How do payouts work?",
      a: "Payout timelines and availability depend on account setup and payment provider processing windows.",
    },
    {
      q: "What is the difference between a business account and freelancer account?",
      a: "Business accounts are for registered businesses managing locations and teams. Freelancer accounts are for independent professionals operating solo.",
    },
    {
      q: "Do I need a business license to join?",
      a: "A business license is required for business-owner account flows. If you do not have one, the freelancer path is the recommended option.",
    },
    {
      q: "How can professionals join a business?",
      a: "Professionals can connect with businesses today and platform job-post matching features are planned for future updates.",
    },
    {
      q: "Can freelancers list products too?",
      a: "Yes, freelancers can maintain their own service and product offerings depending on account setup and feature access.",
    },
    {
      q: "How do customers manage bookings?",
      a: "Customers can book, review details, and manage appointments from their account area and booking history pages.",
    },
    {
      q: "What if I need urgent support?",
      a: "Use the Contact page and include your booking/account details for faster resolution. Support prioritizes active booking and payment issues.",
    },
    {
      q: "How do I get support?",
      a: "Use the Help Center for self-service guidance or Contact for direct assistance.",
    },
  ];

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "980px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Frequently Asked Questions</h1>
          <div style={{ marginTop: "20px", display: "grid", gap: "14px" }}>
            {faqs.map((item, index) => (
              <div key={index} style={{ background: "#f3f4f6", borderRadius: "12px", padding: "18px" }}>
                <h3 style={{ margin: "0 0 8px", color: "#111827", fontSize: "16px" }}>{item.q}</h3>
                <p style={{ margin: 0, color: "#4b5563", lineHeight: "1.7", fontSize: "14px" }}>{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default FAQ;
